/* anvone content sections — shared behaviors.
   Loaded by every anv content section; the __anvSections guard makes duplicate
   <script> tags (one per section instance) harmless. All motion follows the
   repo motion rules: transforms/opacity only, transitions (interruptible),
   IO-gated, reduced-motion respected. */
(function () {
  'use strict';
  if (window.__anvSections) return;
  window.__anvSections = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function init() {
    /* ---------- scroll reveals (skipped if anv-pdp.js already claimed them) ---------- */
    if (!window.__anvRevealDone) {
      window.__anvRevealDone = true;
      if ('IntersectionObserver' in window) {
        var rio = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); rio.unobserve(e.target); } });
        }, { threshold: 0.1 });
        qa('[data-anv-reveal]').forEach(function (n) { rio.observe(n); });
        setTimeout(function () {
          qa('[data-anv-reveal]').forEach(function (n) {
            if (n.getBoundingClientRect().top < window.innerHeight) n.classList.add('in');
          });
        }, 1600);
      } else {
        qa('[data-anv-reveal]').forEach(function (n) { n.classList.add('in'); });
      }
    }

    /* ---------- expanders (grid-rows collapse; button carries both labels) ---------- */
    qa('[data-anv-x-btn]').forEach(function (btn) {
      var target = document.getElementById(btn.getAttribute('aria-controls'));
      if (!target) return;
      btn.addEventListener('click', function () {
        var open = target.classList.toggle('open');
        btn.classList.toggle('open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var label = btn.querySelector('[data-anv-x-label]');
        if (label) {
          var next = open ? btn.getAttribute('data-label-open') : btn.getAttribute('data-label-closed');
          if (next) label.textContent = next;
        }
      });
    });

    /* ---------- accordions (one open at a time within a group) ---------- */
    qa('[data-anv-acc-group]').forEach(function (group) {
      qa('[data-anv-acc-btn]', group).forEach(function (btn) {
        var item = btn.closest('[data-anv-acc-item]');
        btn.addEventListener('click', function () {
          var wasOpen = item.classList.contains('open');
          qa('[data-anv-acc-item]', group).forEach(function (it) {
            it.classList.remove('open');
            var b = it.querySelector('[data-anv-acc-btn]');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          if (!wasOpen) {
            item.classList.add('open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });

    /* ---------- info-tip bubbles (click-to-toggle; one open at a time; outside/Esc closes) ---------- */
    function closeTips(except) {
      qa('[data-anv-tip-home].tip-open').forEach(function (home) {
        if (home === except) return;
        home.classList.remove('tip-open');
        var b = home.querySelector('[data-anv-tip]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    var tips = qa('[data-anv-tip]');
    tips.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var home = btn.closest('[data-anv-tip-home]');
        if (!home) return;
        var open = home.classList.toggle('tip-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) closeTips(home);
      });
    });
    if (tips.length) {
      document.addEventListener('click', function () { closeTips(null); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeTips(null); });
    }

    /* ---------- data-viz micro-behaviors: countup / barfill / vline / stagger ----------
       DOM default IS the resolved final state (correct with no JS and reduced motion);
       JS only resets to the start state and replays when the element scrolls into view. */
    function onView(el, cb, threshold) {
      if (reduce || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { cb(); io.disconnect(); }
      }, { threshold: threshold || 0.35 });
      io.observe(el);
    }
    function fmtNum(el, v) {
      var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
      var str = dec ? v.toFixed(dec) : Math.round(v).toString();
      if (dec) str = str.replace('.', ',');
      else str = str.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      el.textContent = (el.getAttribute('data-pre') || '') + str + (el.getAttribute('data-suf') || '');
    }
    qa('[data-anv-countup]').forEach(function (el) {
      var to = parseFloat(el.getAttribute('data-anv-countup'));
      if (isNaN(to)) return;
      onView(el, function () {
        fmtNum(el, 0);
        var dur = 1300, t0 = performance.now();
        (function step(now) {
          var p = Math.min(1, ((now || performance.now()) - t0) / dur);
          var e = 1 - Math.pow(1 - p, 3);
          fmtNum(el, to * e);
          if (p < 1) requestAnimationFrame(step);
        })();
      }, 0.5);
    });
    qa('[data-anv-barfill]').forEach(function (el) {
      var delay = parseFloat(el.getAttribute('data-anv-barfill') || '0');
      onView(el, function () {
        el.style.transition = 'none';
        el.style.transformOrigin = 'left';
        el.style.transform = 'scaleX(0)';
        void el.getBoundingClientRect();
        el.style.transition = 'transform 1100ms cubic-bezier(0.4, 0, 0.1, 1) ' + delay + 'ms';
        el.style.transform = 'scaleX(1)';
      }, 0.3);
    });
    qa('[data-anv-vline]').forEach(function (el) {
      onView(el, function () {
        el.style.transition = 'none';
        el.style.transformOrigin = 'top';
        el.style.transform = 'scaleY(0)';
        void el.getBoundingClientRect();
        el.style.transition = 'transform 1300ms cubic-bezier(0.4, 0, 0.1, 1)';
        el.style.transform = 'scaleY(1)';
      }, 0.2);
    });
    qa('[data-anv-stagger]').forEach(function (cont) {
      var kids = Array.prototype.slice.call(cont.children);
      var gap = parseInt(cont.getAttribute('data-anv-stagger') || '70', 10);
      onView(cont, function () {
        kids.forEach(function (k) { k.style.transition = 'none'; k.style.opacity = '0'; k.style.transform = 'translateY(12px)'; });
        void cont.getBoundingClientRect();
        kids.forEach(function (k, i) {
          setTimeout(function () {
            k.style.transition = 'opacity 0.5s var(--ease-entry), transform 0.5s var(--ease-entry)';
            k.style.opacity = '1';
            k.style.transform = 'none';
          }, i * gap);
        });
      }, 0.25);
    });

    /* ---------- benchmark chart: bars animate via CSS once .in lands ---------- */
    qa('[data-anv-bench]').forEach(function (sec) {
      var arm = function () { sec.classList.add('bench-in'); };
      if (reduce || !('IntersectionObserver' in window)) { arm(); return; }
      var bio = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { arm(); bio.disconnect(); }
      }, { threshold: 0.35 });
      bio.observe(sec);
    });

    /* ---------- modal (open/close + Esc; backdrop = the root itself) ---------- */
    qa('[data-anv-modal-open]').forEach(function (btn) {
      var modal = document.getElementById(btn.getAttribute('data-anv-modal-open'));
      if (!modal) return;
      var lastFocus = null;
      function close() {
        modal.classList.remove('open');
        document.removeEventListener('keydown', onKey);
        if (lastFocus) lastFocus.focus();
      }
      function onKey(e) { if (e.key === 'Escape') close(); }
      btn.addEventListener('click', function () {
        lastFocus = btn;
        modal.classList.add('open');
        document.addEventListener('keydown', onKey);
        var panel = modal.querySelector('[data-anv-modal-panel]');
        if (panel) { panel.setAttribute('tabindex', '-1'); panel.focus({ preventScroll: true }); }
      });
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      qa('[data-anv-modal-close]', modal).forEach(function (x) { x.addEventListener('click', close); });
    });

    /* ---------- social-proof UGC: IO-gated autoplay tiles + lightbox ---------- */
    var autoTiles = qa('video[data-anv-sp-auto]');
    if (autoTiles.length && 'IntersectionObserver' in window && !reduce) {
      var spio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { var p = e.target.play(); if (p && p.catch) p.catch(function () {}); }
          else e.target.pause();
        });
      }, { threshold: 0.3 });
      autoTiles.forEach(function (v) { spio.observe(v); });
    }
    qa('[data-anv-sp-video]').forEach(function (tile) {
      tile.addEventListener('click', function () {
        var src = tile.getAttribute('data-anv-sp-video');
        if (!src) return;
        var lb = document.createElement('div');
        lb.className = 'anv-sp-lightbox';
        lb.innerHTML = '<button type="button" class="anv-sp-lightbox__close" aria-label="schließen">' +
          '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 6l12 12M18 6 6 18"></path></svg></button>' +
          '<video controls autoplay playsinline></video>';
        lb.querySelector('video').src = src;
        document.body.appendChild(lb);
        requestAnimationFrame(function () { lb.classList.add('open'); });
        function close() {
          lb.classList.remove('open');
          document.removeEventListener('keydown', onKey);
          setTimeout(function () { lb.remove(); }, 300);
        }
        function onKey(e) { if (e.key === 'Escape') close(); }
        document.addEventListener('keydown', onKey);
        lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
        lb.querySelector('.anv-sp-lightbox__close').addEventListener('click', close);
      });
    });

    /* ---------- read-more: 3-line cap, animated height, ghost spacer for equal cards ---------- */
    qa('[data-anv-readmore]').forEach(function (p) {
      requestAnimationFrame(function () {
        var lh = parseFloat(getComputedStyle(p).lineHeight) || 22;
        var collapsed = Math.round(lh * 3);
        if (p.scrollHeight <= collapsed + 6) {
          var ghost = document.createElement('span');
          ghost.className = 'anv-sp__readmore anv-sp__readmore--ghost';
          ghost.setAttribute('aria-hidden', 'true');
          ghost.innerHTML = '&nbsp;';
          p.after(ghost);
          return;
        }
        var wrap = document.createElement('div');
        wrap.className = 'anv-sp__bodywrap collapsed';
        p.parentNode.insertBefore(wrap, p);
        wrap.appendChild(p);
        wrap.style.maxHeight = collapsed + 'px';
        var b = document.createElement('button');
        b.className = 'anv-sp__readmore';
        b.type = 'button';
        b.textContent = 'mehr lesen';
        b.setAttribute('aria-expanded', 'false');
        b.addEventListener('click', function () {
          var isOpen = !wrap.classList.contains('collapsed');
          if (isOpen) {
            wrap.style.maxHeight = collapsed + 'px';
            wrap.classList.add('collapsed');
            b.textContent = 'mehr lesen';
            b.setAttribute('aria-expanded', 'false');
          } else {
            wrap.style.maxHeight = p.scrollHeight + 'px';
            wrap.classList.remove('collapsed');
            b.textContent = 'weniger anzeigen';
            b.setAttribute('aria-expanded', 'true');
          }
        });
        wrap.after(b);
      });
    });

    /* ---------- SVG path draw-in (stroke-dashoffset) on view ---------- */
    qa('path[data-anv-draw], line[data-anv-draw]').forEach(function (path) {
      var len = 0;
      try { len = path.getTotalLength(); } catch (err) { return; }
      if (!len || reduce) return;
      onView(path, function () {
        path.style.transition = 'none';
        path.style.strokeDasharray = len;
        path.style.strokeDashoffset = len;
        void path.getBoundingClientRect();
        var dur = parseFloat(path.getAttribute('data-anv-draw-dur') || '1400');
        path.style.transition = 'stroke-dashoffset ' + dur + 'ms cubic-bezier(0.4, 0, 0.1, 1)';
        path.style.strokeDashoffset = '0';
      }, 0.25);
    });

    /* ---------- gauge needle: rotates from data-from to its inline end angle on view ---------- */
    qa('[data-anv-needle]').forEach(function (el) {
      if (reduce) return;
      var endTransform = el.style.transform;
      onView(el, function () {
        el.style.transition = 'none';
        el.style.transform = 'rotate(' + (el.getAttribute('data-anv-needle-from') || '-90') + 'deg)';
        void el.getBoundingClientRect();
        el.style.transition = 'transform 1400ms cubic-bezier(0.4, 0, 0.1, 1)';
        el.style.transform = endTransform;
      }, 0.35);
    });

    /* ---------- PDP dual-stick: beide Spalten scrollen mit; wer zuerst endet, klebt.
       Kurze Spalte pinnt oben (Header-Offset), lange pinnt, wenn ihr unteres Ende den
       Viewport erreicht. Nur Desktop; mobil raeumen wir die Inline-Styles wieder ab. ---------- */
    qa('[data-anv-dualstick]').forEach(function (grid) {
      var cols = Array.prototype.slice.call(grid.children);
      if (cols.length < 2) return;
      var mq = window.matchMedia('(min-width: 1001px)');
      var ticking = false;
      function apply() {
        if (!mq.matches) {
          cols.forEach(function (c) { c.style.position = ''; c.style.top = ''; });
          return;
        }
        var offset = 96, vh = window.innerHeight;
        cols.forEach(function (c) {
          var h = c.offsetHeight;
          c.style.position = 'sticky';
          c.style.top = (h + offset <= vh) ? offset + 'px' : (vh - h - 24) + 'px';
        });
      }
      function queue() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; apply(); });
      }
      apply();
      window.addEventListener('resize', queue, { passive: true });
      window.addEventListener('load', apply);
      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(queue);
        cols.forEach(function (c) { ro.observe(c); });
      }
    });

    /* ---------- mobile galerie: snap-track <-> thumbs (markup-generisch, age-PDP) ---------- */
    qa('[data-anv-gal]').forEach(function (track) {
      var wrap = track.parentElement;
      var thumbs = qa('[data-anv-gal-thumb]', wrap);
      if (!thumbs.length) return;
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = parseInt(t.getAttribute('data-anv-gal-thumb'), 10);
          var slide = track.querySelector('[data-anv-gal-slide="' + i + '"]');
          if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
      });
      var st;
      track.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        }, 80);
      }, { passive: true });
    });

    /* ---------- dose wall: pause CSS scroll animation while off-screen ---------- */
    if ('IntersectionObserver' in window) {
      qa('[data-anv-wall]').forEach(function (wall) {
        var wio = new IntersectionObserver(function (es) {
          wall.classList.toggle('wall-paused', !es[0].isIntersecting);
        }, { threshold: 0 });
        wio.observe(wall);
      });
    }

    /* ---------- Kreislauf flow: scroll progress lights nodes+connectors sequentially ---------- */
    qa('[data-anv-kflow]').forEach(function (flow) {
      var nodes = qa('.anv-ansatz__node', flow);
      var conns = qa('.anv-ansatz__conn', flow);
      function setPhase(ph) {
        nodes.forEach(function (n, i) { n.classList.toggle('k-on', i <= ph); });
        conns.forEach(function (c, i) { c.classList.toggle('k-on', i + 1 <= ph); });
      }
      if (reduce || !('IntersectionObserver' in window)) { setPhase(nodes.length - 1); return; }
      var ticking = false, current = -2;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var r = flow.getBoundingClientRect(), vh = window.innerHeight;
          var p = (vh * 0.82 - r.top) / (vh * 0.55);
          var ph = -1;
          if (p >= 0.12) ph = 0;
          if (p >= 0.45) ph = 1;
          if (p >= 0.78) ph = 2;
          if (ph !== current) { current = ph; setPhase(ph); }
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      onScroll();
    });

    /* ---------- age teaser: drifting particle canvas (IO-gated, reduced-motion = one static frame) ---------- */
    qa('canvas[data-anv-ageflow]').forEach(function (cv) {
      var ctx = cv.getContext('2d');
      if (!ctx) return;
      function resize() {
        var r = cv.getBoundingClientRect();
        cv.width = Math.max(1, r.width) * 2;
        cv.height = Math.max(1, r.height) * 2;
        ctx.setTransform(2, 0, 0, 2, 0, 0);
      }
      resize();
      window.addEventListener('resize', resize);
      if ('ResizeObserver' in window) { new ResizeObserver(resize).observe(cv); }
      var N = 90, pts = [];
      for (var i = 0; i < N; i++) pts.push({ x: Math.random(), y: Math.random(), sp: 0.1 + Math.random() * 0.25, r: 0.6 + Math.random() * 1.6 });
      function draw(dt) {
        var w = cv.width / 2, h = cv.height / 2;
        ctx.clearRect(0, 0, w, h);
        for (var j = 0; j < pts.length; j++) {
          var p = pts[j];
          p.x += p.sp * dt * 0.04;
          if (p.x > 1.05) { p.x = -0.05; p.y = Math.random(); }
          ctx.fillStyle = 'rgba(255,255,255,' + (0.12 + p.r * 0.12) + ')';
          ctx.beginPath(); ctx.arc(p.x * w, p.y * h, p.r, 0, 6.2832); ctx.fill();
        }
      }
      if (reduce) { draw(0); return; }
      var raf = null, last = null;
      function frame(now) {
        if (last == null) last = now;
        var dt = Math.min(0.05, (now - last) / 1000); last = now;
        draw(dt);
        raf = requestAnimationFrame(frame);
      }
      function start() { if (raf == null) { last = null; raf = requestAnimationFrame(frame); } }
      function stop() { if (raf != null) { cancelAnimationFrame(raf); raf = null; } }
      if ('IntersectionObserver' in window) {
        var fio = new IntersectionObserver(function (es) { es[0].isIntersecting ? start() : stop(); }, { threshold: 0 });
        fio.observe(cv);
      } else {
        start();
      }
    });

    /* ---------- DNA halftone canvas (init on view, pause off-screen) ---------- */
    qa('canvas[data-anv-dna]').forEach(function (cv) {
      var ctx = cv.getContext('2d');
      if (!ctx) return;
      var CSSW = 300, CSSH = 380, GAP = 9, MAXR = GAP * 0.45;
      cv.width = CSSW * 2; cv.height = CSSH * 2; ctx.scale(2, 2);
      var W = CSSW, H = CSSH, x0 = W / 2, R = 74, twist = 0.026;
      function tone(px, py, t) {
        var v = 0;
        var fade = Math.min(1, Math.min(py, H - py) / (H * 0.14));
        for (var s = 0; s < 2; s++) {
          var th = py * twist + t + s * Math.PI;
          var sx = x0 + R * Math.sin(th);
          var depth = (Math.cos(th) + 1) / 2;
          var d = Math.abs(px - sx);
          var tube = 8 * (0.72 + 0.55 * depth);
          if (d < tube) v = Math.max(v, (1 - d / tube) * (0.28 + 0.72 * depth));
        }
        var ry = Math.round(py / 30) * 30;
        if (Math.abs(py - ry) < 4.5) {
          var th2 = ry * twist + t;
          var xa = x0 + R * Math.sin(th2), xb = x0 + R * Math.sin(th2 + Math.PI);
          var lo = Math.min(xa, xb) + 7, hi = Math.max(xa, xb) - 7;
          if (px > lo && px < hi) v = Math.max(v, 0.3 * (1 - (Math.abs(py - ry) / 4.5) * 0.55));
        }
        return v * fade;
      }
      function draw(t) {
        ctx.clearRect(0, 0, W, H);
        ctx.fillStyle = '#000';
        for (var px = GAP / 2; px < W; px += GAP) {
          for (var py = GAP / 2; py < H; py += GAP) {
            var v = tone(px, py, t);
            if (v > 0.04) { ctx.beginPath(); ctx.arc(px, py, MAXR * Math.pow(Math.min(v, 1), 0.8), 0, 6.2832); ctx.fill(); }
          }
        }
      }
      var t = 0.9;
      draw(t);
      if (reduce) return; /* static resolved state */
      var raf = null, last = null;
      function frame(now) {
        if (last == null) last = now;
        t += ((now - last) / 1000) * 0.26; last = now;
        draw(t);
        raf = requestAnimationFrame(frame);
      }
      function start() { if (raf == null) { last = null; raf = requestAnimationFrame(frame); } }
      function stop() { if (raf != null) { cancelAnimationFrame(raf); raf = null; } }
      if ('IntersectionObserver' in window) {
        var dio = new IntersectionObserver(function (es) { es[0].isIntersecting ? start() : stop(); }, { threshold: 0.05 });
        dio.observe(cv);
      } else {
        start();
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
